// @ts-nocheck
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {useMutation} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import axios from 'axios';

interface Response {
  url: string;
  authToken: string;
}

export type RequestDownloadPayload = {
  user_ip: string;
};

export function useRequestDownloadLink(
  id: string,
  payload: RequestDownloadPayload,
) {
  return useMutation({
    mutationFn: () => requestDownload(id, payload),
    onSuccess: async (res: Response) => {
      // console.log(res);
      // toast(message('Downloaded!'));
      downloadFromServer(res.url, res.authToken);
    },
  });
}

export function requestDownload(
  id: string,
  payload: RequestDownloadPayload,
): Promise<Response> {
  return apiClient
    .post(`request/download/${id}`, payload)
    .then(r => {
      if (r.status === 403) {
        toast(message(r.data.message));
      }
      return r.data;
    })
    .catch(err => {
      toast(message(err.response.data.message), {type: 'danger'});
    });
}

export function downloadFromServer(
  downloadUrl: string,
  authToken: string,
): Promise<Response> {
  const textAndNumbers = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ];
  const generateRandomString = () => {
    let result = '';
    for (let i = 0; i < 12; i++) {
      const randomIndex = Math.floor(Math.random() * textAndNumbers.length);
      result += textAndNumbers[randomIndex];
    }
    return result;
  };
  const link = document.createElement('a');
  link.href = `https://${generateRandomString()}.${downloadUrl}`;
  // link.href = `https://${downloadUrl}`;
  link.setAttribute(
    'download',
    downloadUrl.split('/')[downloadUrl.split('/').length - 1],
  );
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
  return;
  // axios({
  //     url: `https://${downloadUrl}`,
  //     method: 'GET',
  //     responseType: 'blob',
  //       headers: {
  //         Authorization: authToken,
  //       },
  //   })
  //     .then(response => {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', 'filename.extension');
  //       document.body.appendChild(link);
  //       link.click();

  //       link.parentNode.removeChild(link);
  //       window.URL.revokeObjectURL(url);
  //     })
  //     .catch(error => {
  //       console.error('File download failed:', error);
  //     });
}
